var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bar"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInGame),expression:"isInGame"}],staticClass:"home-btn",on:{"click":function($event){return _vm.$router.push('/')}}},[_c('img',{attrs:{"src":require("../assets/img/icons/home.png")}})]),_c('TusmoLogo',{staticStyle:{"transform":"scale(0.8)"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }